export default __webpack_public_path__ + "static/media/Catamaran-SemiBold.8917ba21.ttf";